import { Button, Divider, Grid, Paper } from '@material-ui/core'
import React from 'react'
import useEntityManager from '../Solicitacoes/useEntityManager'
import MensagemRepository from './MensagemRepository'
import ReactHtmlParser from 'react-html-parser'
import { useHistory } from 'react-router'

const MensagemView = props => {
  const mensagem = useEntityManager({ repository: MensagemRepository })
  const history = useHistory()
  return (
    <Paper style={{ padding: 16 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ wordWrap: 'break-word' }}>
          <strong>Autor:</strong> {mensagem?.item?.usuario?.nome}
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12} style={{ wordWrap: 'break-word' }}>
          {ReactHtmlParser(mensagem?.item?.mensagem)}
        </Grid>
      </Grid>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: '100%',
          marginRight: 5
        }}
      >
        <Button
          variant="contained"
          color="primary"
          style={{ width: 160 }}
          onClick={() => history.goBack()}
        >
          Voltar
        </Button>
      </div>
    </Paper>
  )
}

export default MensagemView
